import React, { useEffect, useRef } from "react";

/**
 * Video tile that autoplays only when scrolled into view, pauses when out.
 * Always muted + playsInline + loop (browser autoplay policy + iOS friendly).
 * Use inside an image gallery alongside <img> for product / hero media.
 */
const AutoplayVideo = ({ src, poster, className = "", style }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.play().catch(() => {
              // ignore autoplay-blocked errors
            });
          } else {
            el.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <video
      ref={ref}
      src={src}
      poster={poster}
      muted
      playsInline
      loop
      preload="metadata"
      className={className}
      style={style}
    />
  );
};

export default AutoplayVideo;
